export const ADMIN_STATE_STORAGE_KEY = 'admin-state';

const PROFILE_FIELDS = ['f_name', 'l_name', 'email'];

export const mergeStoredAdminState = (patch) => {
  try {
    const raw = localStorage.getItem(ADMIN_STATE_STORAGE_KEY);
    const stored = raw ? JSON.parse(raw) : {};
    localStorage.setItem(ADMIN_STATE_STORAGE_KEY, JSON.stringify({ ...stored, ...patch }));
    return true;
  } catch {
    return false;
  }
};

export const pickAdminProfile = (source) =>
  Object.fromEntries(
    PROFILE_FIELDS.filter((field) => typeof source?.[field] === 'string').map((field) => [
      field,
      source[field]
    ])
  );

export const adminProfileFromCheckToken = (checkToken) =>
  checkToken?.is_admin ? pickAdminProfile(checkToken?.user_data) : {};

export const mergeCheckTokenProfile = (storedBefore, storedNow, checkToken) => {
  const hasProfileChanged = PROFILE_FIELDS.some(
    (field) => storedBefore?.[field] !== storedNow?.[field]
  );
  return hasProfileChanged
    ? { ...storedNow }
    : { ...storedNow, ...adminProfileFromCheckToken(checkToken) };
};
